module.exports = __webpack_public_path__ + "23747e185bc007b91eef166d16272b7e.svg";